import React from 'react';

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const logoStyle = {
  height: 60,
  display: 'block',
  margin: '0 auto',
};

const SweatCoinTheme = {
  headerLogo: {
    src: '/themes/theme/sweatcoin/logo.png',
    alt: 'Sweatcoin Logo',
    size: 45,
  },
  darkLogo: {
    // use new logo
    // src: '/themes/theme/sweatcoin/logo_dark.png',
    src: '/themes/theme/sweatcoin/logo.png',
    alt: 'Sweatcoin Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #001430',
    height: 60,
  },
  linkStyle: {
    color: '#001430',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Sweatcoin',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src="/themes/theme/sweatcoin/logo.png" alt="Sweatcoin Logo"
      />
      <br /><br />
      <h3>Sweatcoin</h3>
    </div>
  ),
  shareSite: 'https://sweatcoinr.dyzio.co',
  organisationId: '8cfa2645-50bc-4700-a548-b9bd6e826ec5',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: '/themes/theme/sweatcoin/logo.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
  primaryButtonColorStyle: {
    background: '#001430',
    color: 'white',
    margin: 5,
  },
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Welcome to Sweatcoin</p>
      <br />
      <p style={textAlignCentre50p}>Join our creator community to help us run competitions and
      other exciting creator activities.</p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Thanks for submitting your application to join our Sweatcoin creator community.
      We will be in touch shortly. Now why don’t you head over to our Instagram page and follow us to
      stay up to date with all our Creator activity!</p>
      <br />

      <br />
      <p style={textAlignCentre}>
        <a href="https://to.mysocial.io/s/sywMulium">
          <img
            href="https://to.mysocial.io/s/sywMulium"
            className="logo"
            style={logoStyle}
            src="/themes/theme/sweatcoin/instagram.png"
            alt="Sweatcoin Instagram"
          />
        </a>
        <a href="https://to.mysocial.io/s/sywMulium">Our Sweatcoin page</a>
      </p>
      <br />
    </div>
  ),
  socialHandle1HtmlBottom: () => (
    <p style={textAlignCentre}>Add your social handles so we can keep track of your posts and stories.</p>
  ),
};

export default SweatCoinTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/sweatcoin.js
 **/